// extracted by mini-css-extract-plugin
export default {"wrapper":"QECe9","breadcrumbs":"ElTrW"};